import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { ActivityForm } from "../ActivityForm";
import { EditActivityModalProps } from "./types";
import { useEditActivityModal } from "./controller";

export const EditActivityModal = React.memo(({ modalRef, onComplete }: EditActivityModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditActivityModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("activity_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <ActivityForm />
    </Modal>
  );
});
